import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactLocationData_contact_postalAddresses_primary_location as ContactLocationData,
    GetContactLocationData as GetContactLocationDataQuery,
    GetContactLocationDataVariables,
} from 'nutshell-graphql-types';

import GET_CONTACT_LOCATION_DATA from '../queries/get-contact-location-data.graphql';

export function useGetContactLocationData(
    contactId: string,
    skip: boolean = false
): {
    contactLocationData: ContactLocationData | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetContactLocationDataQuery,
        GetContactLocationDataVariables
    >(GET_CONTACT_LOCATION_DATA, {
        variables: {id: contactId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        contactLocationData: data?.contact?.postalAddresses?.primary?.location ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
